export var stateColor = function (_a, defaultColor) {
    var alarm = _a.alarm, warning = _a.warning, success = _a.success, theme = _a.theme;
    if (alarm) {
        return theme.colors.alarm;
    }
    if (warning) {
        return theme.colors.warning;
    }
    if (success) {
        return theme.colors.success;
    }
    return defaultColor || theme.colors.primary;
};
export var transitionBase = function (_props, type, duration, timing, delay) {
    if (type === void 0) { type = 'all'; }
    if (duration === void 0) { duration = '120ms'; }
    if (timing === void 0) { timing = 'ease-out'; }
    if (delay === void 0) { delay = ''; }
    return "transition: " + type + " " + duration + " " + timing + " " + delay;
};
export var borderBottomRadius = function (size) { return "\n  border-bottom-left-radius: " + size + "px;\n  border-bottom-right-radius: " + size + "px;\n"; };
export var borderTopRadius = function (size) { return "\n  border-top-left-radius: " + size + "px;\n  border-top-right-radius: " + size + "px;\n"; };
export var borderLeftRadius = function (size) { return "\n  border-top-left-radius: " + size + "px;\n  border-bottom-left-radius: " + size + "px;\n"; };
export var borderRightRadius = function (size) { return "\n  border-bottom-right-radius: " + size + "px;\n  border-top-right-radius: " + size + "px;\n"; };
//# sourceMappingURL=style.js.map